import type { ReploProject } from "schemas/generated/project";

import * as React from "react";

import { ConnectShopifyCallout } from "@editor/components/editor/page/ConnectShopifyCallout";
import { useModal } from "@editor/hooks/useModal";

import IconButton from "@replo/design-system/components/button/IconButton";
import { Tag } from "@replo/design-system/components/tag/Tag";
import { Link2Off } from "lucide-react";

export const ShopifyIntegration: React.FC<{
  project: ReploProject;
}> = ({ project }) => {
  const { openModal } = useModal();
  const shopifyData = project?.integrations?.shopify?.store;

  if (shopifyData) {
    return (
      <div className="space-y-4">
        <div className="flex flex-col gap-2">
          <div className="p-3 border-0.5 border-border rounded-xl w-fit">
            <img
              src="/images/integration-logos/shopify.png"
              alt="Shopify"
              className="w-5 h-5"
            />
          </div>

          <div className="flex flex-col gap-0.5">
            <span className="header-h4">Shopify</span>
            <span className="text-sm text-muted">
              Replo pulls your theme, products, and store info from the store
              below.
            </span>
          </div>
        </div>
        <div className="flex bg-sheet items-center justify-between p-3 border-0.5 rounded-lg border-border">
          <span className="text-base font-medium">
            {project.integrations?.shopify?.store?.shopifyUrl}
          </span>
          <div className="flex items-center gap-2">
            <IconButton
              variant="secondary"
              icon={<Link2Off size={12} />}
              size="sm"
              tooltipText="Disconnect Shopify Store"
              onClick={() => {
                openModal({
                  type: "uninstallShopifyIntegrationModal",
                  props: {
                    workspaceId: project.ownerWorkspaceId,
                    integrationId: shopifyData.integrationId ?? "",
                  },
                });
              }}
            />
            <Tag
              variant="success"
              size="base"
              startEnhancer={
                <img
                  src="/images/shopify-logo.svg"
                  alt="Shopify logo"
                  className="w-4 h-4"
                />
              }
            >
              Connected
            </Tag>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ConnectShopifyCallout
      cookieValue={{
        type: "shopSettingsIntegration",
        projectId: project.id,
        workspaceId: project.ownerWorkspaceId,
      }}
    />
  );
};
